<template>
  <div
    :class="`flex flex-col justify-center items-end px-[16px]
      py-[12px] border-[1px] border-solid border-[#7AA9E9] hover:bg-[#EDF0FA] rounded-[6px]
      ${selected ? 'checkbox-selected' : 'checkbox-default'}
      aria-disabled:bg-[#F8F8F8] aria-disabled:text-[#686868] aria-disabled:border-[#ADADAD] aria-disabled:pointer-events-none`"
    :aria-disabled="disabled"
    @click="selectItem"
  >
    <div class="flex flex-row justify-between w-full items-center">
      <label class="inline-flex items-center">
        <input
          type="checkbox"
          @click="preventDefault"
          :checked="selected"
          class="appearance-none border-[1px] border-solid border-[#3C80DF] w-[24px] h-[24px] rounded-full bg-white checked:bg-[url('!!url-loader!@stylesheets/assets/blue_tick.svg')] bg-no-repeat bg-center aria-disabled:bg-black"
        />
        <span class="ml-[11px] font-bold text-[16px] leading-[140%]">
          {{ text }}
        </span>
      </label>
      <slot name="extra-column" />
    </div>
    <div id="checkbox-description" class="appearance-none">
      <slot name="extra-row" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ text: string; selected?: boolean; disabled?: boolean }>(), {
  selected: false,
  disabled: false,
});

const emit = defineEmits(["choice-selected"]);

function preventDefault(event: MouseEvent) {
  event.preventDefault();
}

function selectItem() {
  emit("choice-selected");
}
</script>

<style scoped>
@tailwind utilities;
.checkbox-selected {
  @apply !bg-[#3C80DF] text-white;
}
.checkbox-default {
  @apply text-[#003F82] bg-white;
}

div[aria-disabled="true"] >>> input {
  @apply !bg-[#F8F8F8] border-[#ADADAD];
}

div[aria-disabled="true"] >>> #checkbox-description {
  @apply text-[#ADADAD];
}
</style>
